
















































































































import { Component } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";

import MagicValidator from "../../../magic/MagicValidator.vue";

import { uploadSingleAttachment } from "../../../api/index";

import { ntko_addon } from "../../../ntko/index";
import { NtkoClientOpenOptions } from "../../../../types/index";

@Component({
  name: "NtkoWidget",
  components: { MagicValidator }
})
export default class NtkoWidget extends WidgetBase {
  private loading: any = null;

  private ntkoUrl: string = "";

  private callback_name: string = "";

  private ext: { attId: string; fileName: string; requestRelativeUri: string } = {
    attId: "",
    fileName: "",
    requestRelativeUri: ""
  };

  private ntko_addon_installed: boolean = false;

  get accept() {
    let accept = "";

    switch (this.widget.filetype) {
      case "WORD":
        accept = ".doc,.docx";
        break;
      case "PDF":
        accept = "application/pdf";
        break;
      case "EXCEL":
        accept = ".xls,.xlsx";
        break;
      case "PPT":
        accept = ".ppt,.pptx";
        break;
      case "ALL":
      default:
        accept = ".doc,.docx,.xls,.xlsx,.ppt,.pptx,application/pdf";
    }
    return accept;
  }

  created() {
    this.callback_name = "onNtkoClientMessage_" + this.widget.id;
    window.NtkoAddonParams.callback[this.callback_name] = (eventName, message) => {
      console.log(this.widget.id + "收到消息" + eventName + ":" + message);
      const data = JSON.parse(message);
      switch (eventName) {
        case "FILE_SAVE_SUCCESS":
          this.onNtkoFileSaveSuccess(data);
          break;
        case "FILE_OPEN_SUCCESS":
          this.onNtkoOpenSuccess(data);
          break;
        case "CLIENT_CLOSE":
          this.onNtkoClose();
          break;
        case "CLOSE_BY_PARENT":
          this.onWidgetClose();
          break;
        default:
          console.log("未知事件");
      }
    };

    this.ext = this.widget.ext || {};

    this.ntko_addon_installed = ntkoBrowser.ExtensionInstalled();
  }

  destroyed() {
    delete window.NtkoAddonParams.callback[this.callback_name];
  }

  onWidgetClose() {
    ntko_addon.close_client();
  }

  onNtkoClose() {
    if (this.loading) {
      this.loading.close();
      this.loading = null;
    }
  }

  onNtkoOpenSuccess(data: any) {
    console.log("文件打开成功", JSON.stringify(data));
    if (!this.loading) {
      this.loading = this.$loading({
        lock: true,
        text: "文档编辑中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    }
  }

  onNtkoFileSaveSuccess(data: any) {
    this.ext.attId = data.attId;
    this.ext.fileName = data.fileName;
    this.ext.requestRelativeUri = data.requestRelativeUri;

    this.$set(this.widget, "value", data.attId);
    this.$set(this, "value", data.attId);
  }

  deleteFile() {
    this.$set(this.widget, "value", "");
  }

  download() {
    const a = document.createElement("a");
    a.href = this.ext.requestRelativeUri;
    a.download = this.ext.fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async onFileChange(data: { raw: File }) {
    const formData = new FormData();
    formData.append("file", data.raw);
    formData.append("propertyNamePath", this.widget.path);
    formData.append("reqToken", this.widget.pac.reqToken);

    try {
      const res = await uploadSingleAttachment(
        this.widget.pac.pacId,
        this.widget.pac.businessId,
        formData
      );
      if (res.success) {
        this.$set(this.widget, "value", res.data.fileId);
        this.$set(this, "value", res.data.fileId);
        this.ext.attId = res.data.fileId;
        this.ext.fileName = res.data.name;
        this.ext.requestRelativeUri = res.data.requestUri;
      }
    } catch (error) {
      console.log(error);
    }
  }

  onUploadSuccess(res: any) {
    console.log(res);
  }

  getNtkoAssetPath() {
    const isproc = process.env.NODE_ENV === "production";
    const path = isproc ? "/process-public-resouce/ntko" : "/ntko";
    let ntkoAssetPath = location.origin + path;

    return ntkoAssetPath;
  }

  async openNtkoAddon() {
    const jwtKey = this.sysconfig.jwtKey;
    const token = this.sysconfig.jwt + "";

    let account: string = "",
      password: string = "";

    if (ntko_addon.account_convert && ntko_addon.password_convert) {
      if (typeof ntko_addon.account_convert === "string") {
        account = ntko_addon.account_convert;
      } else if (typeof ntko_addon.account_convert === "function") {
        account = await ntko_addon.account_convert(this.current);
      }

      if (typeof ntko_addon.password_convert === "string") {
        password = ntko_addon.password_convert;
      } else if (typeof ntko_addon.password_convert === "function") {
        password = await ntko_addon.password_convert(this.current);
      }
    }

    const upload_url = new URL(location.origin + "/api/appproc/hangruan/file/upload");
    upload_url.searchParams.append(jwtKey, token);
    upload_url.searchParams.append("pacId", this.widget.pac.pacId);
    upload_url.searchParams.append("businessId", this.widget.pac.businessId);
    upload_url.searchParams.append("propertyName", this.widget.property.propertyName);

    const file_url = new URL(location.origin + this.ext.requestRelativeUri);
    file_url.searchParams.append(jwtKey, token);

    const options: NtkoClientOpenOptions = {
      readonly: this.widget.readonly || false,
      file_url: file_url.toString(),
      file_name: this.ext.fileName,
      upload_url: upload_url.toString(),
      ntko_account: account,
      ntko_password: password,
      ntko_svrurl: ntko_addon.svr_url,
      licence: ntko_addon.licence,
      callback_name: "NtkoAddonParams.callback." + this.callback_name
    };

    console.log(options);

    ntko_addon.open(options);
  }
}
